"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeSection = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var compositeChartCard_1 = require("../../charts/compositeChartCard");
var lineChartCard_1 = require("../../charts/lineChartCard");
var kpiCard_1 = require("../../charts/kpiCard");
var formatChartData_1 = require("../../../helpers/analytics/formatChartData");
var chartColors_1 = require("../../charts/chartColors");
var dashboardGrid_1 = require("../dashboardGrid");
exports.ChallengeSection = (0, react_1.memo)(function (_a) {
    var _b, _c, _d, _e;
    var data = _a.data, loading = _a.loading;
    var topChallengesData = data && data.top_challenges
        ? data.top_challenges.map(function (challenge) { return ({
            name: challenge.challenge_name.length > 24 ? "".concat(challenge.challenge_name.slice(0, 24), "\u2026") : challenge.challenge_name,
            completion_rate: Math.round(challenge.completion_rate * 10) / 10,
            participation_rate: Math.round(challenge.participation_rate * 10) / 10,
            completions: challenge.completions,
            active: challenge.active_participants,
        }); })
        : [];
    var statusDistribution = (_b = data === null || data === void 0 ? void 0 : data.status_distribution) !== null && _b !== void 0 ? _b : [];
    var participationTrend = (function () {
        var _a;
        if (!(data === null || data === void 0 ? void 0 : data.completion_time_series))
            return [];
        var base = (0, formatChartData_1.formatTimeSeriesForRecharts)(data.completion_time_series);
        if ((_a = data.prev_completion_time_series) === null || _a === void 0 ? void 0 : _a.length) {
            var prev_1 = data.prev_completion_time_series;
            return base.map(function (row, index) { var _a, _b; return (__assign(__assign({}, row), { prev_value: (_b = (_a = prev_1[index]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : null })); });
        }
        return base;
    })();
    var hasPrevCompletion = !!((_c = data === null || data === void 0 ? void 0 : data.prev_completion_time_series) === null || _c === void 0 ? void 0 : _c.length);
    var kpiWidgets = [
        {
            i: "participation",
            label: "Participation Rate",
            value: (0, formatChartData_1.formatPercentage)(data === null || data === void 0 ? void 0 : data.participation_rate),
            sub: "of active users attempted a challenge",
            tooltip: "Share of active users who started at least one challenge in the period.",
        },
        {
            i: "completion",
            label: "Completion Rate",
            value: (0, formatChartData_1.formatPercentage)(data === null || data === void 0 ? void 0 : data.completion_rate),
            sub: "of started challenges completed",
            tooltip: "Of users who started a challenge, the share who reached the 'completed' status.",
        },
        {
            i: "total",
            label: "Total Completions",
            value: (_d = data === null || data === void 0 ? void 0 : data.total_completions) !== null && _d !== void 0 ? _d : 0,
            sub: "out of ".concat((_e = data === null || data === void 0 ? void 0 : data.total_challenges) !== null && _e !== void 0 ? _e : 0, " challenge entries"),
            tooltip: "Count of distinct (user, challenge) pairs with status = completed within the period.",
        },
    ];
    var widgets = __spreadArray(__spreadArray(__spreadArray([], kpiWidgets.map(function (widget, idx) { return ({
        i: widget.i,
        x: idx * 4,
        y: 0,
        w: 4,
        h: 2,
        hideTitle: true,
        noShell: true,
        content: (0, jsx_runtime_1.jsx)(kpiCard_1.KPICard, { title: widget.label, value: widget.value, subtitle: widget.sub, tooltip: widget.tooltip }),
    }); }), true), [
        {
            i: "top_rates",
            x: 0,
            y: 1,
            w: 6,
            h: 4,
            title: "Top Challenges: Rates",
            tooltip: "Top challenges ranked by completion count, shown with completion and participation rates.",
            empty: topChallengesData.length === 0,
            content: ((0, jsx_runtime_1.jsx)(compositeChartCard_1.CompositeChartCard, { title: "Top Challenges: Rates", data: topChallengesData, barKeys: [
                    { key: "completion_rate", name: "Completion Rate (%)", color: chartColors_1.chartColors.success.base },
                    { key: "participation_rate", name: "Participation Rate (%)", color: chartColors_1.chartColors.secondary.base },
                ], xAxisKey: "name", layout: "vertical", noCard: true, loading: loading })),
        },
        {
            i: "top_counts",
            x: 6,
            y: 1,
            w: 6,
            h: 4,
            title: "Top Challenges: Counts",
            tooltip: "Top challenges ranked by completion count, shown with raw completion and active-participant counts.",
            empty: topChallengesData.length === 0,
            content: ((0, jsx_runtime_1.jsx)(compositeChartCard_1.CompositeChartCard, { title: "Top Challenges: Counts", data: topChallengesData, barKeys: [
                    { key: "completions", name: "Completions", color: chartColors_1.chartColors.success.base },
                    { key: "active", name: "Active Participants", color: chartColors_1.chartColors.warning.base },
                ], xAxisKey: "name", layout: "vertical", noCard: true, loading: loading })),
        },
        {
            i: "line_chart",
            x: 0,
            y: 5,
            w: 12,
            h: 4,
            title: "Challenge Completion Trend",
            tooltip: "Distinct (user, challenge) completion events per day.",
            content: ((0, jsx_runtime_1.jsx)(lineChartCard_1.LineChartCard, { title: "Challenge Completion Trend", data: participationTrend, dataKeys: __spreadArray([
                    {
                        key: "value",
                        name: "Completions",
                        color: chartColors_1.chartColors.success.base,
                    }
                ], (hasPrevCompletion
                    ? [
                        {
                            key: "prev_value",
                            name: "Completions (prev period)",
                            color: chartColors_1.chartColors.success.faded,
                            dashed: true,
                        },
                    ]
                    : []), true), xAxisKey: "date", noCard: true, loading: loading })),
        }
    ], false), (statusDistribution.length > 0
        ? [
            {
                i: "status_dist",
                x: 0,
                y: 9,
                w: 12,
                h: 2,
                title: "Challenge Status Distribution",
                tooltip: "Share of challenge entries grouped by status (active, completed, expired, etc) within the period.",
                content: ((0, jsx_runtime_1.jsx)("div", { className: "flex h-full flex-col justify-center gap-3 px-4", children: (0, jsx_runtime_1.jsx)("div", { className: "flex flex-wrap gap-6", children: statusDistribution.map(function (status) { return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)("div", { className: "h-3 w-3 rounded-full bg-primary" }), (0, jsx_runtime_1.jsx)("span", { className: "text-xs text-muted", children: status.status }), (0, jsx_runtime_1.jsxs)("span", { className: "text-sm font-bold text-foreground", children: [status.percentage.toFixed(1), "%"] }), (0, jsx_runtime_1.jsxs)("span", { className: "text-xs text-muted", children: ["(", status.count.toLocaleString(), ")"] })] }, status.status)); }) }) })),
            },
        ]
        : []), true);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-xl font-bold text-foreground", children: "Challenge Performance" }), (0, jsx_runtime_1.jsx)(dashboardGrid_1.DashboardGrid, { widgets: widgets })] }));
});
exports.ChallengeSection.displayName = "ChallengeSection";
